"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeFlatten = exports.nativeFlattenResultSchema = exports.nativeFlattenArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.nativeFlattenArgsSchema = zod_1.z.object({
    array: zod_1.z.array(zod_1.z.any()).describe('The array to flatten'),
    path: zod_1.z
        .string()
        .describe('The path to the array property within each item of the base array. If empty, treats input as a 2D array to flatten directly.'),
    outputSchema: zod_1.z
        .string()
        .describe('The schema for the output array as a JSON Schema. If T is the type of the object, the output schema should be {"type": "object", "properties": { "flattenedArray": {"type": "array", "items": {"type": "T"}}}}'),
    emitMode: common_1.emitModeSchema
        .default('single')
        .describe('Emit mode for the tool. Default to "single".'),
});
// Result schema
exports.nativeFlattenResultSchema = zod_1.z.object({
    flattenedArray: zod_1.z.array(zod_1.z.any()).describe('The flattened array'),
});
// Tool definition
exports.nativeFlatten = (0, common_1.createEmitModeToolMetadata)({
    id: 'nativeFlatten',
    displayName: 'Flatten Array',
    displayDescription: 'Flatten arrays nested within array items using a path, or flatten 2D arrays when path is empty',
    category: 'native',
    color: common_1.BRAND_COLORS.NATIVE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.NATIVE),
    icon: 'flatten',
    argsSchema: exports.nativeFlattenArgsSchema,
}, exports.nativeFlattenResultSchema);
